addQueryPrefix